import React from 'react'
import { Button as ActionButton,Grid, makeStyles } from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(0.5)
    },
    label: {
        textTransform: 'none'
    }
}))

export default function ColumnActions(props) {

    const { text, size,children, color, variant, onClick, ...other } = props
    const classes = useStyles();

    return (
        <Grid container direction="row" justify="center" spacing={3}>
            <Grid item>
                {children}
            </Grid>
        </Grid>
    )
}